import React from 'react';
import { ADivider } from '../../atoms/ADivider/index';
import { MBreadcrumbGroup } from '../../molecules/MBreadcrumbGroup/index';
import { MBreadcrumbGroupBackButtonProps } from '../../molecules/MBreadcrumbGroup/MBreadcrumbGroup.types';
import { MBreadcrumbProps } from '../../molecules/MBreadcrumb/MBreadcrumb.types';
import { OBreadcrumbProps, OBreadcrumbType, OBreadcrumbBackButton } from './OBreadcrumb.types';
import * as Styled from './OBreadcrumb.styles';

export const OBreadcrumb: React.FC<OBreadcrumbProps> = ({ type = OBreadcrumbType.NoBorder, mBreadcrumbGroup }) => {
  return (
    <Styled.OBreadcrumbWrapper data-testid="mi-web-ui-kit-OBreadcrumb" type={type}>
      {type === OBreadcrumbType.TopBorder && <ADivider />}
      <Styled.OBreadcrumbContent>
        <MBreadcrumbGroup
          backButton={mBreadcrumbGroup?.backButton === true || mBreadcrumbGroup?.backButton === 'true'}
          mButton={extractButtonProps(mBreadcrumbGroup?.mButton)}
          mBreadcrumbMulti={extractBreadcrumbItems(mBreadcrumbGroup?.mBreadcrumbMulti ?? [])}
        />
      </Styled.OBreadcrumbContent>
      {type === OBreadcrumbType.BottomBorder && <ADivider />}
    </Styled.OBreadcrumbWrapper>
  );
};

function extractButtonProps(mButton: OBreadcrumbBackButton | undefined): MBreadcrumbGroupBackButtonProps {
  return {
    ...(mButton?.buttonText ? { buttonText: mButton?.buttonText } : {}),
    ...(mButton?.ctaLink ? { href: mButton?.ctaLink, isExternal: mButton?.openInANewTab === 'true' } : {}),
  };
}

function extractBreadcrumbItems(
  mBreadcrumbMulti: Array<{
    aTextInteractive: {
      text: string;
      ctaLink?: string | null;
    };
  }>
): MBreadcrumbProps[] {
  return mBreadcrumbMulti.map((item, idx) => ({
    aTextInteractive: {
      text: item.aTextInteractive?.text,
      ...(idx < mBreadcrumbMulti.length - 1 ? { href: item.aTextInteractive?.ctaLink || undefined } : {}),
    },
  }));
}
